// extracted by mini-css-extract-plugin
export default {"button":"xr-z","reviewSort":"yr-z"};